import React from 'react'
import PropTypes from 'prop-types'

import { useMultiSelect } from './_hooks'
import { Select01, Select04, Select03 } from './_elements'
import SubQuestionTitle from '../SubQuestionTitle'

const MultiSelect = ({ component, step, updatedSelected }) => {
  const [isSelected, handleSelect] = useMultiSelect({
    component,
    step
  })

  const Component = (() => {
    switch (component.type) {
      case 'multi-select-1':
        return Select01
      case 'multi-select-3':
        return Select03
      case 'multi-select-4':
      default:
        return Select04
    }
  })()

  return (
    <>
      {component?.subQuestion ? (
        <SubQuestionTitle subQuestion={component.subQuestion} />
      ) : null}
      <Component
        handleSelect={handleSelect}
        component={component}
        isSelected={isSelected}
        step={step}
        updatedSelected={updatedSelected}
      />
    </>
  )
}

MultiSelect.propTypes = {
  component: PropTypes.object.isRequired,
  updatedSelected: PropTypes.any
}

export default MultiSelect
